import config from "config-base";

export const GuestMenu = [
  { title: 'Sign In', url: config.signInUrl },
  { title: 'Create Account', url: config.signUpUrl }
]

export const UserMenu = [
  { title: 'My Account', url: config.myAccountUrl },
  { title: 'My Orders', url: config.myOrdersUrl },
  { title: 'Bullseye Bucks', url: config.bullseyeBucksUrl },
  { title: 'Gift Cards', url: config.myGiftCardUrl }
]
